export default class Manufacturer {
    constructor() {
        this.id = "";
        this.name = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
    }
}